/**
 * Heat Loss Caculator
 * ===
 * Heat Loss Statement View
 * 
 * Extends Backbone View.
 *
 * Author: Duncan McMillan
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */
'use strict';

import _ from 'underscore';
import Backbone from 'backbone';

import { HLC_Utils } from './../HeatLossCalculator.Utils.js';

/**
 * Heat Loss Statement View
 *
 */
export var HeatLossStatementView = Backbone.View.extend({
    
    tagName: 'section',
    className: 'hlc-section hlc-heat-loss-statement-pane is-inactive',
    
    template: undefined,
    model: undefined,
    
    initialize: function(options) {
        
        this.template = _.template(options.template);
        
        return this;
    },
    
    render: function() {
        
        var data, heat_loss_w;
        
        data = this.model.toJSON();
        
        data.total_heat_loss_w = this.model.totalHeatLoss();
        data.total_heat_loss_btu = HLC_Utils.wattsToBtus(this.model.totalHeatLoss());
        
        this.$el.html(this.template(data));
        
        return this;
    }
});
